import en from './languages/en.json'
import { type Query, TranslationDocument } from 'datocms/models'
import { request } from 'datocms/request'
import { Settings } from 'luxon'
import { addMessages, init } from 'svelte-i18n'
import { t } from 'svelte-i18n'

export const _ = t

type FormatXMLElementFn<T, R = string | T | (string | T)[]> = (parts: Array<string | T>) => R

type InterpolationValues =
	| Record<
			string,
			string | number | boolean | Date | FormatXMLElementFn<unknown> | null | undefined
	  >
	| undefined
export interface MessageObject {
	id: string
	locale?: string
	format?: string
	default?: string
	values?: InterpolationValues
}
export type MessageFormatter = (
	id: string | MessageObject,
	options?: Omit<MessageObject, 'id'>,
) => string

export function i18nLink(href: string, text: string, target = '_self'): string {
	const anchor = document.createElement('a')
	anchor.href = href
	anchor.textContent = text
	if (target) {
		anchor.target = target
	}
	anchor.classList.add('underline-link')

	return anchor.outerHTML
}

export function i18nLinkChunk(href: string) {
	return (chunks) =>
		`<a href="${href}" target="_blank" class="underline hover:no-underline">${chunks}</a>`
}

export enum Lang {
	en = 'en',
}

function deepMerge(target: object, source: object): object {
	const result = { ...target }

	for (const key in source) {
		if (source[key] !== null && typeof source[key] === 'object' && !Array.isArray(source[key])) {
			result[key] = deepMerge(result[key] || {}, source[key])
		} else {
			result[key] = source[key]
		}
	}

	return result
}

export async function loadLangFromCms(code: string, tenantId?: string) {
	const response = await request<Query>(TranslationDocument, { code, tenantId })

	const baseTranslations = response.translation?.content || {}
	const customTranslations =
		response.translation?._allReferencingCustomTenantTranslations?.[0]?.content || {}

	return tenantId ? deepMerge(baseTranslations, customTranslations) : baseTranslations
}

export function initI18n(): void {
	addMessages(Lang.en, en)
	Settings.defaultLocale = Lang.en

	init({
		fallbackLocale: Lang.en,
		initialLocale: Lang.en,
		ignoreTag: false,
	})
}
